import { combineReducers } from "@reduxjs/toolkit";
import admins from "./admins";
import merchants from "./merchants";
import orders from "./orders";
import drivers from "./drivers";
import zones from "./zones";
import submerchants from "./submerchants";
import contactUsMessages from "./contactUsMessages";
import notifications from "./notifications";
import profile from "./profile";
import connections from "./connections";
import warehouse from "./warehouse";
import assignOrders from "./assignOrders";
import adminBlog from "./adminBlog";
import completedOrdersCount from "./completedOrdersCount";
import customizations from "./customizations";
import confirmationDialog from "./confirmationDialog";
import creditsAndSubscription from "./creditsAndSubscription";
import cities from "./cities";
import tutorial from "./tutorial";

const entities = combineReducers({
    admins,
    merchants,
    orders,
    submerchants,
    drivers,
    zones,
    contactUsMessages,
    notifications,
    profile,
    connections,
    warehouse,
    assignOrders,
    adminBlog,
    completedOrdersCount,
    customizations,
    confirmationDialog,
    creditsAndSubscription,
    cities,
    tutorial
});

export default entities;